export const APP_URL = document.querySelector('base').getAttribute('href').replace(/(\/)*$/, "");
export const APP_PATH = (() => {
	var el = document.createElement('a');
		el.href = APP_URL;
	return el.pathname;
})()